import React, { useEffect, useState } from "react";
import { api } from "../api/api";
import { useAuth } from "../context/AuthContext";
const API_BASE = process.env.REACT_APP_API_URL?.replace("/api","") || "http://localhost:5115";

const GRUPPEN = [
  { label: "🥛 Weidemilch", namen: ["Weidemilch 1 Liter", "Weidemilch 2 Liter", "Weidemilch 3 Liter"] },
  { label: "🍫 Kakao",      namen: ["Kakao 1 Liter", "Kakao 2 Liter"] },
  { label: "🥚 Eier",       namen: ["Freilandeier 10er Pack"] },
];

export default function Produkte() {
  const { user } = useAuth();
  const [produkte, setProdukte] = useState([]);
  const [loading, setLoading]   = useState(true);
  const [error, setError]       = useState(null);

  useEffect(() => {
    api.produkte.getAll()
      .then(data => setProdukte(data.filter(p => p.name !== "Lieferpauschale")))
      .catch(() => setError("Produkte konnten nicht geladen werden."))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="loader">Produkte werden geladen...</div>;
  if (error)   return <div className="container"><div className="alert alert-error">{error}</div></div>;

  return (
    <div className="container">
      <h2 className="section-title">Unsere Produkte</h2>

      {GRUPPEN.map((gruppe, gi) => {
        const gruppenProdukte = gruppe.namen
          .map(n => produkte.find(p => p.name === n))
          .filter(Boolean);
        if (gruppenProdukte.length === 0) return null;
        return (
          <div key={gi}>
            {gi > 0 && <hr style={{ border: "none", borderTop: "1.5px solid #e0e0e0", margin: "1.5rem 0" }} />}
            <div className="card-grid">
              {gruppenProdukte.map((p) => (
                <div className="card" key={p.produktId}>
                  {p.bildUrl && (
                    <img src={`${API_BASE}${p.bildUrl}`} alt={p.name}
                      style={{ width: "100%", height: 350, objectFit: "cover", borderRadius: 8, marginBottom: "0.75rem" }} />
                  )}
                  <span className="badge">{gruppe.label}</span>
                  <h3>{p.name}</h3>
                  <p style={{ color: "#666", fontSize: "0.9rem", margin: "0.5rem 0" }}>{p.beschreibung}</p>
                  <div className="preis">{p.preis.toFixed(2)} € / {p.einheit}</div>
                  {p.istVerfuegbar
                    ? <span className="badge">✓ Verfügbar</span>
                    : <span className="badge" style={{ background: "#ffebee", color: "#c62828" }}>Nicht verfügbar</span>
                  }
                </div>
              ))}
            </div>
          </div>
        );
      })}

      {/* ── Registrieren-CTA (nur für nicht eingeloggte Besucher) ── */}
      {!user && (
        <div style={{
          marginTop: "3rem",
          background: "linear-gradient(135deg, #e8f5e9, #c8e6c9)",
          borderRadius: "16px",
          padding: "2.5rem 2rem",
          textAlign: "center",
          border: "2.5px solid #66bb6a",
          boxShadow: "0 4px 16px rgba(46,125,50,0.15)",
        }}>
          <div style={{ fontSize: "2.5rem", marginBottom: "0.5rem" }}>🛒</div>
          <h2 style={{ color: "#1b5e20", marginBottom: "0.75rem", fontSize: "1.6rem" }}>
            Direkt vom Hof zu Ihnen nach Hause
          </h2>
          <p style={{ color: "#388e3c", marginBottom: "1.75rem", fontSize: "1rem", maxWidth: 480, margin: "0 auto 1.75rem" }}>
            Registrieren Sie sich kostenlos und bestellen Sie frische Milchprodukte als Abo oder Einzelbestellung.
          </p>
          <button
            onClick={() => window.dispatchEvent(new CustomEvent("open-auth-modal"))}
            style={{
              background: "#2e7d32", color: "white", border: "none", cursor: "pointer",
              fontSize: "1.15rem", fontWeight: "700",
              padding: "0.9rem 2.75rem", borderRadius: "50px",
              boxShadow: "0 6px 20px rgba(46,125,50,0.4)",
            }}>
            🔑 Jetzt registrieren
          </button>
          <div style={{ marginTop: "1rem" }}>
            <span style={{ color: "#388e3c", fontSize: "0.9rem" }}>Bereits Kunde? </span>
            <button
              onClick={() => window.dispatchEvent(new CustomEvent("open-auth-modal"))}
              style={{
                background: "none", border: "none", cursor: "pointer",
                color: "#2e7d32", fontWeight: 700, fontSize: "0.9rem",
                textDecoration: "underline", padding: 0,
              }}>
              Anmelden
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
